module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Code-4115197c7f478fc7f6e290742912aefe.svg";